{
  "startNew": "Commencer nouveau",
  "table": {
    "createdAt": "Exécuté à",
    "completedAt": "Terminé à",
    "state": "État",
    "files": "Fichiers",
    "organization": "Organisation"
  },
  "state": {
    "CANCELED": "Annulé",
    "COMPLETED": "Terminé",
    "DRAFT": "Brouillon",
    "REQUESTED": "Demandé"
  },
  "allocationFile": "Allocations",
  "ptfAllocationFile": "Allocations de PTF",
  "generating": "Génération en cours",
  "reviewTrades": "Examiner les opérations",
  "updateTrades": "Mettre à jour les exécutions d'opération",
  "reviewTradeAllocations": "Examiner les allocations d'opérations",
  "updatePTFTrades": "Mettre à jour les exécutions d'opération PTF",
  "reviewPTFTradeAllocations": "Examiner les allocations d'opérations PTF",
  "completed": "Terminé",
  "generatingDescription": "Les opérations sont en cours de génération…",
  "rebalanceOn": "Rééquilibré le",
  "rebalanceCanceled": "Le rééquilibrage est annulé. Revenez en arrière pour en lancer un nouveau.",
  "tradeViaFix": "Opération via FIX",
  "bulkBUYTrades": "Opérations d'achat groupées",
  "bulkSELLTrades": "Opérations de vente groupées",
  "bulkMutualFundBUYTrades": "Achats avec le fonds commun groupé",
  "bulkMutualFundSELLTrades": "Ventes sur le fonds commun groupé",
  "amountValue": "Valeur",
  "cancelRebalanceTrades": "Annuler les opérations de rééquilibrage",
  "rebalanceCompleted": "Rééquilibrage terminé",
  "allPricesNotUpdated": "Les prix n'ont pas encore tous été mis à jour",
  "pasteFromExcel": "Copier/coller à partir d'Excel",
  "orderOfContent": "Vérifiez que les colonnes sont par ordre de symbole, prix, quantité",
  "cancelConfirmationDialog": "Avant d'annuler, vérifiez que vous n'avez pas envoyé les fichiers d'opérations groupées. Si vous avez déjà envoyé les fichiers d'opérations groupées, le système génèrera une ERREUR, car toutes ces opérations ont été envoyées au dépositaire.",
  "cancelTriggeredMessage": "L'annulation des opérations de rééquilibrage a été déclenchée!",
  "discrepancyConfirmationDialog": {
    "title": "Divergences dans les opérations groupées",
    "text": "Il existe des divergences dans les quantités ou les prix alloués. Voulez-vous vraiment continuer?"
  },
  "orderOfPortfolioContent": "Vérifiez que les colonnes sont par ordre de symbole et de pourcentage",
  "generate": "Générer",
  "bulkTraderOn": "Opération groupée réalisée le",
  "bulkTradeRunCompleted": "Opération groupée terminée",
  "bulkTradeRunCanceled": "Exécution de l'opération groupée annulée",
  "saveTradesMessage": "Enregistrez vos opérations pour continuer.",
  "securitiesWereNotFound": "Valeurs mobilières introuvables : {{securities}}",
  "dialog": {
    "title": "Demande d'opérations groupées"
  },
  "security": "Valeur mobilière",
  "price": "Prix",
  "quantity": "Quantité",
  "save": "Enregistrer",
  "update": "Mettre à jour",
  "cancel": "Annuler",
  "back": "Retour",
  "next": "Suivant",
  "cancelBulkTradeRunTrades": "Annuler les opérations d'exécution groupée",
  "buyTradeFile": "Fichier d'opérations d'achat",
  "sellTradeFile": "Fichier d'opérations de vente",
  "mutualFundTradeFile": "Fichier d'opérations de fonds communs de placement",
  "buySellTradeFile": "Fichier d'opérations d'achat/vente",
  "ptfBulkTradeFile": "Fichier d'opérations groupées PTF"
}
